// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  version: '3.8.0',
  ceServerURL: 'https://i76auggcj2.execute-api.us-east-1.amazonaws.com/dev/',
  chatbots: [{
      Id : 'd5849c10-9cb7-11ee-87d6-0d0d6a330c2e',
      language : 'en'
    },
    {
      Id : '5424f080-99c8-11ee-9aa6-bb58d493022b',
      language : 'ar'
    }],

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
